const API_URL = process.env.REACT_APP_API_URL;

// GET tous les rôles avec leurs permissions
export async function getRoles() {
    const response = await fetch(`${API_URL}/role`, {
      method: "GET",
      credentials: "include",
    });
  
    if (!response.ok) {
      throw new Error("Non authentifié");
    }

    return response.json();
}

// POST créer un nouveau rôle
export async function createRole(roleData) {
    const response = await fetch(`${API_URL}/role`, {
        method: "POST",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            role: {
                nom: roleData.nom
            }
        })
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la création du rôle");
    }

    return response.json();
}

// PUT mettre à jour un rôle
export async function updateRole(roleId, roleData) {
    const response = await fetch(`${API_URL}/role/${roleId}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            role: {
                nom: roleData.nom
            }
        })
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la modification du rôle");
    }

    return response.json();
}

// DELETE supprimer un rôle
export async function deleteRole(roleId) {
    const response = await fetch(`${API_URL}/role/${roleId}`, {
        method: "DELETE",
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la suppression du rôle");
    }

    return response.json();
}

// PUT mettre à jour les permissions d'un rôle
export async function updateRolePermissions(roleId, permissionIds) {
    const response = await fetch(`${API_URL}/role/${roleId}/permissions`, {
        method: "PUT",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            role: {
                permissions: permissionIds
            }
        })
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la mise à jour des permissions");
    }

    return response.json();
}

export async function removeRolePermissions(roleId, permissionIds) {
    const response = await fetch(`${API_URL}/role/${roleId}/permissions`, {
        method: "DELETE",
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ role: { permissions: permissionIds } })
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la suppression des permissions");
    }

    return response.json();
}
  